import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="overflow-hidden">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center bg-gradient-to-br from-slate-50 via-cleaning-blue-50/30 to-fresh-white pt-20">
        {/* Background Elements */}
        <div className="absolute inset-0 bg-grid-pattern opacity-50" />
        <div className="blob w-96 h-96 bg-cleaning-blue-200 top-20 -right-20" />
        <div className="blob w-80 h-80 bg-action-green-200 bottom-20 -left-20 animation-delay-2000" />
        
        <div className="container-custom relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="animate-slide-up">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-cleaning-blue-100 text-cleaning-blue-700 rounded-full text-sm font-medium mb-6">
                <span className="w-2 h-2 bg-action-green-500 rounded-full animate-pulse" />
                Commercial Cleaning Lead Generation
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6">
                Commercial Cleaning Walkthroughs—
                <span className="gradient-text">Pre-Set for You.</span>
              </h1>
              
              <p className="text-xl text-slate-600 mb-8 max-w-xl">
                We book the appointments with decision-makers. 
                <span className="font-semibold text-slate-800"> You just show up and bid.</span>
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/book-now" className="btn-primary text-lg px-8 py-4">
                  Book Appointments Now
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </Link>
                <a 
                  href="https://squeakyleads.network" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn-outline text-lg px-8 py-4"
                >
                  Free Job Board
                </a>
              </div>

              {/* Trust Indicators */}
              <div className="mt-12 flex items-center gap-8">
                <div className="flex -space-x-3">
                  {[1, 2, 3, 4].map((i) => (
                    <div
                      key={i}
                      className="w-10 h-10 bg-gradient-to-br from-cleaning-blue-400 to-cleaning-blue-600 rounded-full border-2 border-white flex items-center justify-center text-white text-xs font-bold"
                    >
                      {String.fromCharCode(64 + i)}
                    </div>
                  ))}
                </div>
                <div>
                  <p className="text-sm text-slate-500">Trusted by</p>
                  <p className="font-semibold text-slate-800">100+ Cleaning Companies</p>
                </div>
              </div>
            </div>

            {/* Right Visual */}
            <div className="relative hidden lg:block animate-fade-in">
              <div className="relative">
                {/* Main Card */}
                <div className="bg-white rounded-3xl shadow-2xl shadow-slate-200/50 p-8 border border-slate-100">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-14 h-14 bg-gradient-to-br from-action-green-400 to-action-green-600 rounded-2xl flex items-center justify-center">
                      <svg className="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-sm text-slate-500">Next Appointment</p>
                      <p className="font-bold text-slate-900">Tomorrow, 2:00 PM</p>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                      <div className="w-10 h-10 bg-cleaning-blue-100 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-cleaning-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <p className="font-medium text-slate-800">Medical Office Building</p>
                        <p className="text-sm text-slate-500">45,000 sq ft • Atlanta, GA</p>
                      </div>
                      <span className="px-3 py-1 bg-action-green-100 text-action-green-700 text-xs font-semibold rounded-full">
                        Confirmed
                      </span>
                    </div>
                    
                    <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                      <div className="w-10 h-10 bg-cleaning-blue-100 rounded-lg flex items-center justify-center">
                        <svg className="w-5 h-5 text-cleaning-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <p className="font-medium text-slate-800">Corporate Headquarters</p>
                        <p className="text-sm text-slate-500">120,000 sq ft • Dallas, TX</p>
                      </div>
                      <span className="px-3 py-1 bg-yellow-100 text-yellow-700 text-xs font-semibold rounded-full">
                        Pending
                      </span>
                    </div>
                  </div>
                </div>
                
                {/* Floating Stats Card */}
                <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 border border-slate-100 animate-float">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-cleaning-blue-500 to-cleaning-blue-600 rounded-xl flex items-center justify-center">
                      <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                      </svg>
                    </div>
                    <div>
                      <p className="text-2xl font-bold text-slate-900">85%</p>
                      <p className="text-sm text-slate-500">Close Rate</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="section-padding bg-white">
        <div className="container-custom">
          {/* Section Header */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-4 py-2 bg-action-green-100 text-action-green-700 rounded-full text-sm font-semibold mb-4">
              Simple Pricing
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Pay Per Appointment.
              <span className="gradient-text"> No Contracts.</span>
            </h2>
            <p className="text-lg text-slate-600">
              Transparent pricing with no hidden fees. Choose what works for your business.
            </p>
          </div>

          {/* Pricing Cards */}
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Single Walkthrough */}
            <div className="card-hover pricing-card-glow group">
              <div className="mb-6">
                <span className="text-sm font-semibold text-cleaning-blue-600 uppercase tracking-wide">
                  Starter
                </span>
                <h3 className="text-2xl font-bold text-slate-900 mt-2">Single Walkthrough</h3>
                <p className="text-slate-500 mt-2">Perfect for trying our service</p>
              </div>
              
              <div className="flex items-baseline gap-2 mb-6">
                <span className="text-5xl font-bold text-slate-900">$200</span>
                <span className="text-slate-500">/ appointment</span>
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  'Pre-qualified decision maker',
                  'Confirmed appointment time',
                  'Building details provided',
                  'Square footage information',
                  'Contact information included',
                ].map((feature, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 bg-action-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-action-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-600">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/book-now" className="btn-secondary w-full justify-center">
                Get Started
              </Link>
            </div>

            {/* Scale Pack */}
            <div className="card-hover pricing-card-glow relative overflow-hidden border-2 border-action-green-500">
              {/* Popular Badge */}
              <div className="absolute top-0 right-0 bg-action-green-500 text-white text-xs font-bold px-4 py-1 rounded-bl-xl">
                BEST VALUE
              </div>

              <div className="mb-6">
                <span className="text-sm font-semibold text-action-green-600 uppercase tracking-wide">
                  Most Popular
                </span>
                <h3 className="text-2xl font-bold text-slate-900 mt-2">The Scale Pack</h3>
                <p className="text-slate-500 mt-2">For serious growth</p>
              </div>
              
              <div className="flex items-baseline gap-2 mb-2">
                <span className="text-5xl font-bold text-slate-900">$1,500</span>
                <span className="text-slate-500">/ 10 appointments</span>
              </div>
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-action-green-100 text-action-green-700 rounded-full text-sm font-semibold mb-6">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Save $500
              </div>

              <ul className="space-y-4 mb-8">
                {[
                  'Everything in Single Walkthrough',
                  '10 pre-set appointments',
                  'Priority scheduling',
                  'Dedicated account support',
                  'Flexible delivery timeline',
                ].map((feature, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="w-5 h-5 bg-action-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-action-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-slate-600">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link to="/book-now" className="btn-primary w-full justify-center">
                Get The Scale Pack
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="section-padding bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern opacity-5" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-cleaning-blue-500 rounded-full filter blur-[150px] opacity-10" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-action-green-500 rounded-full filter blur-[150px] opacity-10" />
        
        <div className="container-custom relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-4 py-2 bg-white/10 text-cleaning-blue-300 rounded-full text-sm font-semibold mb-4 backdrop-blur-sm">
              The Process
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              How Our Leads
              <span className="text-action-green-400"> Work</span>
            </h2>
            <p className="text-lg text-slate-400">
              We do the hard work of finding and qualifying prospects. You just show up ready to win.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            {[
              {
                step: '1',
                title: 'We Prospect',
                description: 'We identify commercial properties actively looking for cleaning services.',
                icon: (
                  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                ),
              },
              {
                step: '2',
                title: 'We Qualify',
                description: 'We speak with decision-makers and confirm interest in receiving quotes.',
                icon: (
                  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                ),
              },
              {
                step: '3',
                title: 'We Schedule',
                description: 'We book a walkthrough appointment at a time that works for both parties.',
                icon: (
                  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                ),
              },
              {
                step: '4',
                title: 'You Bid',
                description: 'You show up to the confirmed appointment, walk the building, and present your proposal.',
                icon: (
                  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                ),
              },
            ].map((item, i) => (
              <div key={i} className="text-center group">
                <div className="relative">
                  <div className="w-16 h-16 bg-gradient-to-br from-cleaning-blue-500 to-cleaning-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-cleaning-blue-500/30">
                    {item.icon}
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-action-green-500 rounded-full flex items-center justify-center text-white text-sm font-bold">
                    {item.step}
                  </div>
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{item.title}</h3>
                <p className="text-slate-400 text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Squeakyleads Network Job Board Section */}
      <section className="section-padding bg-gradient-to-br from-action-green-50 to-teal-50">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-action-green-100 text-action-green-700 rounded-full text-sm font-semibold mb-6">
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                100% Free Job Board
              </span>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
                Squeakyleads
                <span className="text-action-green-600"> Network</span>
              </h2>
              
              <p className="text-xl text-slate-600 mb-8">
                Connect with opportunities in the commercial cleaning industry. 
                <span className="font-semibold text-slate-800"> Free to post jobs. Free to apply.</span>
              </p>

              <div className="grid sm:grid-cols-2 gap-4 mb-8">
                <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
                  <div className="w-12 h-12 bg-cleaning-blue-100 rounded-xl flex items-center justify-center mb-4">
                    <svg className="w-6 h-6 text-cleaning-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h3 className="font-bold text-slate-900 mb-2">For Businesses</h3>
                  <p className="text-slate-600 text-sm">Post jobs and find reliable cleaners for your contracts. No fees, no subscriptions.</p>
                </div>
                
                <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
                  <div className="w-12 h-12 bg-action-green-100 rounded-xl flex items-center justify-center mb-4">
                    <svg className="w-6 h-6 text-action-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <h3 className="font-bold text-slate-900 mb-2">For Cleaners</h3>
                  <p className="text-slate-600 text-sm">Browse opportunities and apply for cleaning jobs. Build your career, no cost.</p>
                </div>
              </div>

              <a
                href="https://squeakyleads.network"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-8 py-4 bg-action-green-600 text-white font-bold text-lg rounded-xl shadow-lg shadow-action-green-500/30 hover:bg-action-green-700 hover:shadow-xl hover:-translate-y-1 active:scale-[0.98] transition-all duration-200"
              >
                Visit the Job Board
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>

            {/* Right Visual */}
            <div className="relative">
              <div className="bg-white rounded-3xl shadow-xl p-8 border border-slate-100">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="font-bold text-slate-900">Recent Opportunities</h3>
                  <span className="text-xs font-semibold text-action-green-600 bg-action-green-100 px-3 py-1 rounded-full">FREE</span>
                </div>
                
                <div className="space-y-4">
                  {[
                    { title: 'Office Cleaning Crew Needed', location: 'Atlanta, GA', type: 'Part-time' },
                    { title: 'Medical Facility Cleaner', location: 'Dallas, TX', type: 'Full-time' },
                    { title: 'Subcontractor for Retail Chain', location: 'Phoenix, AZ', type: 'Contract' },
                  ].map((job, i) => (
                    <div key={i} className="flex items-center gap-4 p-4 bg-slate-50 rounded-xl">
                      <div className="w-10 h-10 bg-cleaning-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <svg className="w-5 h-5 text-cleaning-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-medium text-slate-900 truncate">{job.title}</p>
                        <p className="text-sm text-slate-500">{job.location}</p>
                      </div>
                      <span className="text-xs font-medium text-slate-600 bg-slate-200 px-2 py-1 rounded">{job.type}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-6 pt-6 border-t border-slate-100 text-center">
                  <p className="text-sm text-slate-500">Join thousands connecting through the network</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-4 py-2 bg-cleaning-blue-100 text-cleaning-blue-700 rounded-full text-sm font-semibold mb-4">
              Why Squeakyleads
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
              Focus on Cleaning.
              <span className="gradient-text"> We Handle the Rest.</span>
            </h2>
            <p className="text-lg text-slate-600">
              Stop wasting time on cold calls and dead-end leads. Get in front of real decision-makers.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                ),
                title: 'Pre-Qualified Leads',
                description: 'Every lead has confirmed interest in receiving cleaning quotes. No tire-kickers, no wasted time.',
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                ),
                title: 'Confirmed Appointments',
                description: 'We schedule the walkthrough for you. All you do is show up at the confirmed time and place.',
              },
              {
                icon: (
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                ),
                title: 'No Contracts',
                description: 'Pay per lead with no monthly fees or long-term commitments. Scale up or down as you need.',
              },
            ].map((item, i) => (
              <div key={i} className="text-center p-8 bg-slate-50 rounded-3xl hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-gradient-to-br from-cleaning-blue-500 to-cleaning-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h3>
                <p className="text-slate-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section-padding bg-slate-50">
        <div className="container-custom">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="inline-block px-4 py-2 bg-cleaning-blue-100 text-cleaning-blue-700 rounded-full text-sm font-semibold mb-4">
              Got Questions?
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-lg text-slate-600">
              Everything you need to know about our lead generation service.
            </p>
          </div>

          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6">
            {[
              {
                question: 'How do your walkthrough appointments work?',
                answer: 'We connect you with decision-makers who are ready for cleaning quotes. You receive confirmed appointment details including building info, square footage, and contact information. Just show up and bid.',
              },
              {
                question: 'What\'s included in each lead?',
                answer: 'Every lead includes: pre-qualified decision maker contact, confirmed appointment time, building address and details, square footage, and the type of cleaning services needed.',
              },
              {
                question: 'How quickly will I receive appointments?',
                answer: 'Most clients receive their first appointment within 30 days. Scale Pack customers often see faster delivery due to priority scheduling.',
              },
              {
                question: 'What if a lead doesn\'t show up?',
                answer: 'We stand behind our appointments. Invalid leads are replaced if reported before your deadline. We want you to succeed.',
              },
              {
                question: 'What types of buildings do you cover?',
                answer: 'We cover all commercial niches including medical offices, corporate buildings, retail, industrial, education, and more. Leads span various cleaning services from daily janitorial to specialized work.',
              },
              {
                question: 'Do you serve my area?',
                answer: 'We work with cleaning companies across the United States. Contact us with your service area and we\'ll let you know about lead availability in your region.',
              },
            ].map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                <h3 className="text-lg font-bold text-slate-900 mb-2">{faq.question}</h3>
                <p className="text-slate-600">{faq.answer}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <p className="text-slate-600 mb-4">Still have questions?</p>
            <a
              href="mailto:squeakyleads@gmail.com"
              className="inline-flex items-center gap-2 text-cleaning-blue-600 font-semibold hover:text-cleaning-blue-700 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Contact us at squeakyleads@gmail.com
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gradient-to-r from-cleaning-blue-600 to-cleaning-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-white rounded-full filter blur-[150px] opacity-10" />
        
        <div className="container-custom relative z-10 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Grow Your Cleaning Business?
          </h2>
          <p className="text-xl text-cleaning-blue-100 mb-10 max-w-2xl mx-auto">
            Stop cold calling. Start showing up to pre-set appointments with decision-makers ready to hear your bid.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/book-now"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-cleaning-blue-600 font-bold text-lg rounded-xl shadow-xl hover:shadow-2xl hover:-translate-y-1 active:scale-[0.98] transition-all duration-200"
            >
              Get Started Today
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
            <a
              href="https://squeakyleads.network"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent border-2 border-white text-white font-bold text-lg rounded-xl hover:bg-white/10 active:scale-[0.98] transition-all duration-200"
            >
              Free Job Board
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
